import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'hud-media-mode';

export const MEDIA_MODES = ['photo', 'video'];

/**
 * Whether the camera panels show the newest still or the newest video from
 * each camera. Purely a display choice, remembered per browser like the
 * anchor -- it never asks the device to capture anything.
 */
export function useMediaMode() {
  const [mode, setModeState] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (MEDIA_MODES.includes(stored)) return stored;
    } catch (e) {}

    return 'photo';
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch (e) {}
  }, [mode]);

  const setMode = useCallback((next) => {
    if (MEDIA_MODES.includes(next)) setModeState(next);
  }, []);

  return [mode, setMode];
}
